import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { HelmetProvider } from "react-helmet-async";
import { QueryClientProvider } from "react-query";
import DirectProcessModal from "../shared/DirectProcessModal";
import PtsModal from "../shared/PtsModal";
import SashAddModal from "../shared/SashAddModal";

import { queryClient } from "../util/reactQuery";

const ErrorFallback = () => {
    return (
        <div style={{ width: "100vw", height: "100vh", margin: "10vh auto" }}>
            <div
                style={{
                    width: "30vw",
                    textAlign: "center",
                    margin: "10vh auto",
                }}
            >
                <p style={{ color: "red" }}>앗, 문제가 생겼어요!</p>
                {/* <p>금방 완료될거예요. 잠시만 기다려주세요! :)</p> */}
                <button
                    style={{
                        padding: "1vw",
                        borderRadius: "5px",
                        background: "#2c2c2c",
                        color: "#fff",
                    }}
                    onClick={() => {
                        window.location.assign(window.location.origin);
                    }}
                >
                    돌아가기
                </button>
            </div>
        </div>
    );
};
export const AppProvider = ({ children }) => {
    return (
        <React.Suspense
            fallback={
                <div
                    style={{
                        display: "flex",
                        width: "100vw",
                        textAlign: "center",
                        margin: "2vh 0",
                    }}
                >
                    로딩 중입니다...
                </div>
            }
        >
            <ErrorBoundary FallbackComponent={ErrorFallback}>
                <HelmetProvider>
                    <QueryClientProvider client={queryClient}>
                        <PtsModal />
                        <SashAddModal />
                        <DirectProcessModal />
                        {children}
                    </QueryClientProvider>
                </HelmetProvider>
            </ErrorBoundary>
        </React.Suspense>
    );
};
